import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function TireInstallationPage() {
  return <div data-id="element-1155">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-black" data-id="element-1156">
        <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" data-id="element-1157" />
        <div className="relative z-10" data-id="element-1158">
          <p className="text-[#CC0000] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1159">
            Our Services
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1160">
            ⚙️ Tire Installation & Balancing
          </h1>
          <div className="w-12 h-0.5 mx-auto mt-4 mb-4" style={{
          background: '#FECB00'
        }} data-id="element-1161" />
          <p className="text-gray-300 text-base max-w-xl mx-auto" data-id="element-1162">
            Precision installation by certified technicians for a smooth, safe
            ride every time.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1163">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1164">
          <div data-id="element-1165">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1166">
              Installed Right. Balanced Perfectly.
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1167">
              Improper tire installation can lead to dangerous vibrations,
              uneven wear, and even blowouts. At Ameritech Tires, our certified
              technicians use state-of-the-art mounting and balancing equipment
              to ensure every tire is installed to manufacturer specifications.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1168">
              Tire balancing distributes weight evenly across the tire and wheel
              assembly, eliminating vibration and extending tire life. We
              balance every tire we install — no exceptions. Whether you bought
              tires from us or brought your own, we'll get the job done right.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1169">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1170">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1171">
              <li className="flex items-start gap-3" data-id="element-1172">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1173" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1174">
                  Professional mounting on all vehicle types
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1175">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1176" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1177">
                  Computer-aided dynamic wheel balancing
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1178">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1179" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1180">
                  Valve stem replacement included
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1181">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1182" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1183">
                  Torque-to-spec lug nut tightening
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1184">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1185" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1186">
                  TPMS sensor check and reset
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1187">
                <CheckCircle2Icon size={20} className="text-[#822433] flex-shrink-0 mt-0.5" data-id="element-1188" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1189">
                  Post-installation safety inspection
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1190">
        <div className="max-w-5xl mx-auto" data-id="element-1191">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1192">
            Why Professional Installation Matters
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1193">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1194">
              <div className="text-3xl mb-3" style={{
              background: '#CC0000'
            }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-1195">
                🔧
              </div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1196">
                Precision Equipment
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1197">
                We use calibrated torque wrenches and computerized balancers —
                not guesswork.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1198">
              <div className="text-3xl mb-3" data-id="element-1199">🚗</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1200">
                Smooth Ride
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1201">
                Balanced tires eliminate steering wheel vibration and uneven
                wear patterns.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1202">
              <div className="text-3xl mb-3" data-id="element-1203">⏱️</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1204">
                Fast Turnaround
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1205">
                Most installations are completed within 45–60 minutes. Walk-ins
                welcome.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1206">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1207">
          Ready to Get Started?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1208">
          Book your installation appointment today — same-day service available
          at all 3 locations.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1209">
          <Link to="/contact" className="inline-flex items-center justify-center bg-[#822433] hover:bg-[#6B1D29] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1210">
            Book an Appointment
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1211">
            View All Services
          </Link>
        </div>
      </section>
    </div>;
}